import { Link } from "react-router-dom";
import type { GalleryItem } from "@/types/content";

interface FeaturedGalleryProps {
  items: GalleryItem[];
}

export default function FeaturedGallery({ items }: FeaturedGalleryProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/gallery?streamer=${encodeURIComponent(item.streamerName)}`}
          className="group relative block aspect-[3/4] rounded-lg overflow-hidden bg-background-100"
        >
          <img
            src={item.image}
            alt={`${item.streamerName} ${item.theme}写真`}
            title={`${item.streamerName} 韩国女主播写真`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-4">
            <span className="inline-block px-2 py-0.5 rounded-full text-[11px] bg-accent-500 text-background-50 mb-1.5">
              {item.theme}
            </span>
            <p className="text-background-50 font-heading font-semibold text-base">{item.streamerName}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}